import { createFileRoute } from '@tanstack/react-router';
import { ThreeDSError, ThreeDSLoading } from '../components/pages/ThreeDSPage/ThreeDSState';
import { ThreeDSPage } from '../components/pages/ThreeDSPage/ThreeDSPage';

export const Route = createFileRoute('/3ds/$code')({
  component: ThreeDSPage,
  errorComponent: ThreeDSError,
  pendingComponent: ThreeDSLoading,
});
